import Resource from './Resource';

export default class ClassPageAssignmentBinSubmission extends Resource {
	constructor(options={}) {
		let {
			routeParams = {},
			query = {},
			data = {},
		} = options;

		let assignmentBinType = '';
		if( options.type === 'course' ){
			assignmentBinType = 'dropboxes';
		}

		if( options.type === 'group' ){
			assignmentBinType = 'student-group-dropboxes';
		}

		if( options.type === 'student' ){
			assignmentBinType = 'student-dropboxes';
		}

		let config = {
			route: `class-pages/:courseSectionGuid/${assignmentBinType}/:assignmentBinId/assignments/:assignmentId/submissions`,
			query: query,
			data: data,
			routeParams: routeParams,
		};
		super(config);
		return this;
	}

	post() {
		return this.request('post');
	}
}
